import { deleteObject, getDownloadURL, listAll, ref as storageRef, uploadBytes } from 'firebase/storage';
import { storage } from '../firebase/config';
import { IMAGE_WEBP_EXT, IMAGE_WEBP_MIME } from '../utils/imageCompress';
import { buildUserStoragePath } from '../utils/userStoragePaths';

const getMemberPhotoPath = (userId: string, classId: string, memberId: string) =>
  buildUserStoragePath(userId, classId, 'MemberProfile', `${memberId}.${IMAGE_WEBP_EXT}`);

const getLegacyMemberPhotoPath = (userId: string, classId: string, memberId: string) =>
  buildUserStoragePath(userId, classId, 'MemberProfile', `${memberId}.jpg`);

export const memberProfilePhotoService = {
  async uploadMemberPhoto(userId: string, classId: string, memberId: string, blob: Blob): Promise<{ path: string; url: string }> {
    const path = getMemberPhotoPath(userId, classId, memberId);
    try {
      await deleteObject(storageRef(storage, getLegacyMemberPhotoPath(userId, classId, memberId)));
    } catch (error: any) {
      if (error?.code !== 'storage/object-not-found') throw error;
    }
    const fileRef = storageRef(storage, path);
    await uploadBytes(fileRef, blob, {
      contentType: IMAGE_WEBP_MIME,
      // 브라우저/중간 캐시의 재검증 빈도를 낮춰 재방문 시 표시 속도를 개선
      cacheControl: 'public, max-age=86400'
    });
    const url = await getDownloadURL(fileRef);
    return { path, url };
  },

  async deleteMemberPhoto(userId: string, classId: string, memberId: string): Promise<void> {
    const path = getMemberPhotoPath(userId, classId, memberId);
    try {
      await deleteObject(storageRef(storage, path));
    } catch (error: any) {
      if (error?.code !== 'storage/object-not-found') {
        throw error;
      }
    }
  },

  async deleteMemberPhotosBatch(userId: string, classId: string, memberIds: string[]): Promise<void> {
    for (const memberId of memberIds) {
      await this.deleteMemberPhoto(userId, classId, memberId);
    }
  },

  async deleteClassMemberProfileFolder(userId: string, classId: string): Promise<void> {
    const folderRef = storageRef(storage, buildUserStoragePath(userId, classId, 'MemberProfile'));
    try {
      const list = await listAll(folderRef);
      for (const itemRef of list.items) {
        await deleteObject(itemRef);
      }
    } catch (error: any) {
      if (error?.code !== 'storage/object-not-found') {
        throw error;
      }
    }
  }
};
